import React from 'react'
import { useQuery } from '@tanstack/react-query';
import { getViewsSummaryByUser } from '../../server-functions/views';
import Table from '../../global/components/YkTable';
import { printTable } from '../../utils/print-pdf';
import { exportToExcel } from '../../utils/export-excel/excel';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import { formatWatchTime } from "../../global/functions";
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import { viewsSummaryTableColumns } from '../../global/settings/tableColumns';

dayjs.locale('he');


function ViewsSummary() {
    const {
        data: summaryData,
        status: summaryStatus,
        refetch: refetchSummary
    } = useQuery({
        queryKey: ['views-summary'],
        queryFn: getViewsSummaryByUser
    });

    // עיבוד נתוני סיכום
    const processedSummaryData = React.useMemo(() => {
        return (summaryData || []).map(row => ({
            ...row,
            totalWatchTimeFormatted: formatWatchTime(row.totalWatchTime),
        }));
    }, [summaryData]);

    const summaryActions = [
        {
            label: "רענן נתונים",
            icon: <RefreshIcon style={{ fontSize: 18 }} />,
            onClick: refetchSummary
        },
        {
            label: "הפקת אקסל",
            icon: <DownloadIcon style={{ fontSize: 18 }} />,
            onClick: (data) => {
                const mapped = (data || []).map(row => ({
                    'שם משתמש': row.userName,
                    'אימייל': row.userEmail,
                    'טלפון': row.userPhone,
                    'סרטונים שפתח': row.lessonsOpened,
                    'צפיות שהושלמו': `${row.lessonsCompleted} / ${row.totalLessons}`,
                    'זמן צפייה כללי': row.totalWatchTimeFormatted,
                    'אחוז זמן כללי': `${row.watchTimePercentage}%`,
                    'צפייה אחרונה': row.lastWatched
                        ? dayjs(row.lastWatched).format('DD/MM/YYYY HH:mm')
                        : 'לא צפה',
                }));
                exportToExcel(mapped, [], "סיכום צפיות");
            }
        },
        {
            label: "הדפס",
            icon: <LocalPrintshopIcon style={{ fontSize: 18 }} />,
            onClick: (data) => {
                const mapped = (data || []).map(row => ({
                    userName: row.userName,
                    userEmail: row.userEmail,
                    userPhone: row.userPhone,
                    lessonsOpened: row.lessonsOpened,
                    lessonsCompleted: `${row.lessonsCompleted} / ${row.totalLessons}`,
                    totalWatchTime: row.totalWatchTimeFormatted,
                    watchTimePercentage: `${row.watchTimePercentage}%`,
                    lastWatched: row.lastWatched
                        ? dayjs(row.lastWatched).format('DD/MM/YYYY HH:mm')
                        : 'לא צפה',
                }));
                const printColumns = [
                    { key: 'userName', title: 'שם משתמש' },
                    { key: 'userEmail', title: 'אימייל' },
                    { key: 'userPhone', title: 'טלפון' },
                    { key: 'lessonsOpened', title: 'פתח' },
                    { key: 'lessonsCompleted', title: 'השלים' },
                    { key: 'totalWatchTime', title: 'זמן כללי' },
                    { key: 'watchTimePercentage', title: 'אחוז זמן' },
                    { key: 'lastWatched', title: 'צפייה אחרונה' },
                ];
                printTable(mapped, printColumns, "סיכום צפיות");
            }
        },
    ];

    return (
        <Table
            title="סיכום כללי לפי משתמש"
            columns={viewsSummaryTableColumns}
            data={processedSummaryData}
            loading={summaryStatus === 'pending'}
            refetch={refetchSummary}
            actions={summaryActions}
        />
    );
}

export default ViewsSummary;
